<template>
  <div>
    <SfeLayout column-gap="0">
      <template #header>
        <SfeTopNav
            :hasReadNotifications="getNotificationCount.length < 1 ? true : false"
            :hasUserRoleDropdown="false"
            :showSearchIconToggler="false"
            v-sclickoutside="hideOptions"
            :hasSearch="Boolean(isSuperAdmin)"
            @input="handleSeachEmit"
            placeholder="Search... (Cmd+K or Ctrl+K)"
            @show:notification="handleShowNotification"
            ref="searchInputFocus"
        >
          <template #companyLogo>
            <div>
              <a href="/" title="SeamlessHiring Homepage">
                <img v-if="currentCompany?.logo_link" class="navbar-company-logo" :src="currentCompany?.logo_link">
                <img v-else class="navbar-company-logo" src="/img/seamlesshiring-logo.png">
              </a>
            </div>
          </template>
          <template #searchList>
            <div 
              class="bg-white mt-n2 search-result-item border-radius-8 border-line-grey-1"
              style="max-height: 400px; box-shadow: rgba(17, 12, 46, 0.2) 0 48px 100px 0;"
            >
              <div
                v-if="search.length">
                <div>
                  <GlobalSearch
                    :actions="filteredActions"
                    :job-data="jobData"
                    :is-super-admin="Boolean(isSuperAdmin)"
                    :applicant-data="applicantData"
                    :search-query="search"
                    :applicant-loading-state="applicantLoadingState"
                    :job-loading-state="jobLoadingState"
                    @action:taken="takeAction"
                    @go-to:talent-pool="goToTalentPool"
                    @go-to:job-appliaction="goToJobAppliaction"
                    @view:applicant="goToApplicantPage"
                  />
                </div>
              </div>
              <div v-if="shortCutUsed && !search.length">
                <p class="px-3 py-3 text-muted text-center">
                  Start typing...
                </p>
              </div>
            </div>
          </template>
          <template #notificationsList>
            <AppNotification
                :user="user"
                :showIconBell="false"
                :displayLightBox="showNotificationsLightBox"
                emptyStateMessage="There are no new updates to display here"
                @notification-count="getNotificationCount"
            />
          </template>

          <template #userAvatar>
            <SfeDropdown>
              <template #trigger>
                <SfeClickable class="d-flex align-items-start">
                  <SfeAvatar
                      :src="$helpers.createInitialsFromStr($helpers.getObjectProperty(user, 'name'))"
                      :initials="$helpers.createInitialsFromStr($helpers.getObjectProperty(user, 'name'))"
                      size="lg"
                      status="success"
                      shape="circle"
                  />
                  <div class="ml-2 d-flex align-items-center justify-content-start">
                    <div class="text-left">
                      <SfeTooltip position="left" :content="$helpers.getObjectProperty(currentCompany, 'name')">
                        <template #trigger>
                          <div class="fw-500 mb-0 fs-15 truncated-text">
                            {{ $helpers.getObjectProperty(currentCompany, 'name', '') }}
                          </div>
                        </template>
                      </SfeTooltip>
                      <div class="text-muted fs-13">Time zone: {{ $helpers.getObjectProperty(user, 'timezone') }}</div>
                    </div>
                    <div class="ml-2">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.793 7.73271C16.0787 8.03263 16.0672 8.50737 15.7672 8.79306L10.5168 13.7944C10.2271 14.0703 9.77187 14.0703 9.4822 13.7944L4.23173 8.79306C3.93181 8.50737 3.92028 8.03263 4.20597 7.73271C4.49166 7.43279 4.96639 7.42125 5.26631 7.70694L9.99949 12.2155L14.7327 7.70694C15.0326 7.42125 15.5073 7.43279 15.793 7.73271Z" fill="#454545"/>
                      </svg>
                    </div>
                  </div>

                </SfeClickable>
              </template>

              <template #list>
                <SfeList>
                  <SfeDropdown v-if="companies.length > 1" isSubMenu position="right">
                    <template #trigger>
                      <SfeListItem>
                        <div class="d-flex align-items-center w-100">
                          <div class="mr-2">
                            <SfeSvgIcon name="Chevron Left" size="12" />
                          </div>
                          <div>
                            <p class="mb-0 fw-400 fs-15">Switch subsidiaries</p>
                            <p class="mb-0 fs-12 fw-400 text-muted">Current: {{ $helpers.getObjectProperty(currentCompany, 'name') }}</p>
                          </div>
                        </div>
                      </SfeListItem>
                    </template>
                    <template #list>
                      <SfeList class="shr-shadow"
                          searchable
                          placeholder="Search for a subsidiary"
                          @search:query="handleSearchItemValue"
                          style="width: 350px !important;"
                      >
                        <div style="height: 700px; overflow-y: auto" v-if="filteredCompanies.length">
                          <div v-for="(company, i) in filteredCompanies" :key="i + 'company-switch'" style="overflow-wrap: break-word; white-space: normal;">
                            <SfeListItem :disabled="company.id == currentCompany?.id" @click.prevent="switchUserCompanies(company.id)">
                              <div class="d-flex justify-content-between align-items-center">
                                <div :class="company.id == currentCompany?.id ? '' : 'company-list-item'">
                                  <p class="mb-0 fw-400 fs-14 cv-name">{{ company.name }}</p>
                                  <p class="mb-0 fw-400 fs-12 cv-name">{{ company.timezone }}</p>
                                </div>
                                <div v-if="company.id == currentCompany?.id" >
                                  <p class="mb-0 text-primary fw-500 fs-12">Active</p>
                                </div>
                              </div>
                            </SfeListItem>
                          </div>
                        </div>
                        <div v-else>
                          <SfeListItem class="mb-0 disable-bg-light-grey-1">No result for {{ subsidiarySearch }}</SfeListItem>
                        </div>
                      </SfeList>
                    </template>
                  </SfeDropdown>
                  <SfeDivider v-if="companies.length > 1" class="my-3"/>
                  <SfeListItem style="min-width: 200px" @click.prevent="handleLogout">
                    <i class="fa fa-sign-out"></i> Logout
                  </SfeListItem>
                </SfeList>
              </template>
            </SfeDropdown>
          </template>
        </SfeTopNav>
      </template>

      <template #sidebar>
        <SfeSidebar width="245px" @collapsed="isSidebarCollapsed = $event" v-if="user">
          <SfeSidebarHeader
              :module="module"
              :modulesList="modules"
              :canSwitchModules="false"
          />

          <SfeSidebarBody>

            <div
                v-for="(item, index) in linksToShow"
                :key="index"
            >
              <div v-if="item.group">
                <SfeSidebarOption
                    :title="item.group"
                    :level="1"
                    hasSections
                >
                  <RouterLink
                      v-for="link in item.items"
                      :to="{name: link.routeName}"
                      :key="link.title"
                  >
                    <SfeSidebarOption
                        :title="link.title"
                        :level="2"
                        :isActive="isSidebarSubLinkActive(link)"
                        isSubsection
                    >
                    </SfeSidebarOption>
                  </RouterLink>
                  <template #optionIcon>
                    <div v-html="determineActiveTab(item) ? item.activeIcon : item.icon"></div>
                  </template>
                </SfeSidebarOption>
              </div>
              <RouterLink
                  v-else
                  :to="{name: item.routeName}"
              >
                <SfeSidebarOption
                    :title="item.title"
                    :level="1"
                    :isActive="isSidebarSubLinkActive(item)"
                >
                  <template #optionIcon>
                    <div v-html="isSidebarSubLinkActive(item) ? item.activeIcon : item.icon"></div>
                  </template>
                </SfeSidebarOption>
              </RouterLink>
            </div>
            <!-- External links -->
            <div>
              <div>
                <div class="my-3">
                  <SfeDivider />
                </div>
                <p v-if="!isSidebarCollapsed" class="mb-0 fw-400 text-muted fs-16 ml-2 mt-3">OTHER</p>
              </div>
              <div
                  v-for="(item, index) in externalLinks"
                  :key="index">
                <a
                    :href="item?.url ? item?.url : hrmsDetails?.url"
                    :class="item.title == 'HRMS Portal' && !hrmsDetails ? 'd-none' : ''"
                    target="_blank"
                >
                  <SfeSidebarOption
                      :title="item.title"
                      :isActive="item.routeName === $route.name"
                      :level="1"
                  >
                    <template #optionIcon>
                      <div v-html="item.routeName === $route.name ? item.activeIcon : item.icon"></div>
                    </template>
                  </SfeSidebarOption>
                </a>
              </div>
            </div>
            <!-- External links -->
            <div>
              <div class="tour-guide-section mt-5" v-if="routeHasTourGuide && !isSidebarCollapsed">
                <div
                    class="d-flex align-items-center justify-content-between bg-white px-2 py-3 br-8"
                    @click.prevent="TourGuideMixin().handleTourButtonClick()"
                >
                  <div>
                    <p class="fs-12 font-weight-bold sidebar-text mb-1 mr-0">See what's new and how it works</p>
                    <p class="fs-12 text-primary sidebar-text mb-0 mr-0">Take a tour of this page</p>
                  </div>

                  <!-- <div class="tour-guide-section__non-hover-img" role="button">
                    <img src="/homepage/images/carcass-icons/tour-guide-non-hover.svg" alt="dashboard tour guide start button"/>
                  </div> -->
                  <div class="tour-guide-section__hover-img" role="button">
                    <img
                        src="/homepage/images/carcass-icons/tour-guide-hover.svg"
                        alt="dashboard tour guide start button"
                    />
                  </div>
                </div>
              </div>
              <div style="margin-left: -11px;" v-if="isSidebarCollapsed" @click.prevent="TourGuideMixin().handleTourButtonClick()" class="tour-guide-section__hover-img" role="button">
                <img
                    src="/homepage/images/carcass-icons/tour-guide-hover.svg"
                    alt="dashboard tour guide start button"
                />
              </div>
            </div>

          </SfeSidebarBody>

          <SfeSidebarFooter :userDetails="computedUser">
            <SfeList class="w-100">
              <SfeListItem @click.prevent="handleLogout">
                <i class="fa fa-sign-out"></i> Logout
              </SfeListItem>
            </SfeList>
          </SfeSidebarFooter>
        </SfeSidebar>
      </template>

      <template #content>
        <main class='pb-2 me-4 new-main-content' :style="`max-width: calc(100vw - ${isSidebarCollapsed ? '64px' : '245px'})`">
          <div v-if="!showBackOnline" class="d-flex h-100 w-100 justify-content-center align-items-center">
            <div class="text-center">
              <img src="/homepage/images/jobs-list-empty-state.png" style="height: 120px;" alt="No internet">
              <h1 class="text-muted">No Internet connection!</h1>
              <div class="text-muted mt-3">Internet connection is needed for this page to continue functioning.</div>
            </div>
          </div>
          <div v-else >
            <slot></slot>
            <ShrFloatingNotification
                :notifications="notifications"
                :showFloatingBar="true"
                @goToNotificationList="goToList"
                @close="showFloatingBar = false"
            />
          </div>
        </main>
      </template>
    </SfeLayout>
    <SfeDialog :hasCloseIcon="false"
        :is-modal-open="idleModal.open"
    >
      <template #header>
        <p>Session Timeout Warning</p>
      </template>
      <template #body>
        <p>
          Your session will expire in <b>{{ idleModal.secondsLeft }}</b> seconds.<br>
          Do you want to stay logged in?
        </p>
      </template>
      <template #footer>
        <SfeButton
            class="flex-grow-1"
            @click="idleTimeoutService.userChoseToStayLoggedIn()"
        >Stay Logged In</SfeButton>

        <SfeButton
            @click="idleTimeoutService.userChoseToLogout()"
            intent="critical"
            variant="outline"
            class="me-2 ml-2 flex-grow-1"
        >
          Logout
        </SfeButton>
      </template>
    </SfeDialog>
  </div>
</template>

<script>
import UserModel from "../../models/UserModel";
import AdminModel from "../../models/AdminModel";
import TourGuideMixin from '../../mixins/TourGuideMixin';
import AppNotification from "../../components/AppNotification"
import SfeLayout from "@insidify/shr-ui-library/src/new-components/Layout/SfeLayout"
import HorizontalListLoader from "../admin/jobs/job-management/applicant-tracking-system/includes/loaders/utility/HorizontalList"
import JobModel from "../../models/JobModel"
import algoliasearch from 'algoliasearch'
import AsymmetricEncryptionService from "../../services/AsymmetricEncryptionService"
import SideBarDataMixin from "../../mixins/SideBarDataMixins";
import AlertService from "../../services/AlertService";
import IdleTimeoutService from "../../services/IdleTimeoutService";
import Fuse from "fuse.js";
import Actions from "../../config/actions";
import GlobalSearch from "./GlobalSearch.vue";


// Using AsymmetricEncryptionService instead of deprecated LaravelEncrypt
export default {
  name: 'AdminLayout',
  mixins: [
      AlertService,
    UserModel,
    AdminModel,
    JobModel,
    TourGuideMixin,
    SideBarDataMixin,
    Actions

  ],
  props: {
    showFloatingBar: {
      type: Boolean,
      default: true
    },
    userDetails: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    AppNotification,
    GlobalSearch,
    HorizontalListLoader,
    SfeLayout,
  },
  data(){
    return {
      allActions: Actions,
      matchedActions: [],
      shortCutUsed: false,
      hasUsedTheGlobalSearch: false,
      inputSearchValue: '',
      // sidebar data properties
      isSidebarCollapsed: false,
      module: 'Recruitment Portal',
      subsidiarySearch: '',
      //
      search: '',
      companies: [],
      onLine: navigator.onLine,
      showBackOnline: true,
      currentCompany: null,
      sidebarItems: [],
      notifications: [],
      user: {},
      notificationCount: 0,
      isLoading: true,
      jobLoadingState: false,
      jobData: [],
      applicantLoadingState: false,
      applicantData: {},
      searchClient: null,
      algoliaIndexing: null,
      showNotificationsLightBox: false,
      logoutChannel: null,
      idleTimeoutService: null,
      idleModal: {
        open: false,
        secondsLeft: 30,
      }
    }
  },
  computed: {
    filteredActions() {
      const filtered = this.matchedActions.filter(action => {
      const permissions = this.$helpers.getObjectProperty(action, 'item.permissions', '');

      if (permissions === "") {
        return true;
      }

      return this.can(permissions)
    });

      return filtered;
    },
    filteredCompanies() {
      if(!this.subsidiarySearch) return this.companies;

      return this.companies.filter(item => item.name.toLowerCase().includes(this.subsidiarySearch));
    },
    isSuperAdmin() {
      return Boolean(this.$helpers.getObjectProperty(this.user, 'is_super_admin', 0));
    },
    linksToShow() {
      return this.$helpers.getObjectProperty(this.user, 'is_super_admin', 0) ? this.superAdminLinks : this.systemAdminLinks;
    },
    actionsToShow() {
      return this.$helpers.getObjectProperty(this.user, 'is_super_admin', 0) ? this.allActions?.superAdminActions : this.allActions?.jobAdminActions;
    },
    computedUser() {
      const user = this.user ?? {};
      const fullName = typeof user.name === 'string' ? user.name.trim() : '';
      const [firstName, ...rest] = fullName.split(/\s+/);
      const lastName = rest.join(' ');

      return {
        ...user,
        firstName: firstName || '',
        lastName: lastName || '',
        avatar: {
          src: user.src ?? '',
          alt: 'Logged in user photo',
        },
      };
    },
    routeHasTourGuide() {
      const routeName = this.$route.name
      const routesWithTourGuide = [
        'Admin.Applicants.Overview',
        'Admin.Applicants.Applications.Step',
        'Admin.Applicants.JobPreferences',
        'Admin.Applicants.JobTeam',
        'Admin.Applicants.KanbanApplications',
        'Admin.Dashboard',
        'Admin.Applicants.CandidateOverview',
        'Admin.Applicants.CandidateProfile',
        'Applicant.Overview',
        'Admin.Audit.Trail',
        'Applicant.Assessments',
        'Admin.Settings.Permissions',
        'Admin.Templates.InterviewNotes',
        'Admin.Settings.Permissions.Edit',
      ]
      return routesWithTourGuide.includes(routeName)
    },
    hrmsDetails(){
      const hrmsDetails = this.$helpers.getObjectProperty(this.currentCompany, 'client.hrms_details')
      if (!hrmsDetails?.is_linked) return null;

      return hrmsDetails
    },
    adminCanSeeJobManagement() {
      return (!!this.$helpers.getObjectProperty(this.user, 'roles', []).length
              && this.$helpers.getObjectProperty(this.user, 'roles', [])
                  .some(v => ['admin','interviewer','commenter','check_admin','test_admin']
                      .includes(v.name)))
          || this.userIsSuperAdmin
    },
    userIsSuperAdmin() {
      return !!this.$helpers.getObjectProperty(this.user, 'is_super_admin', 1)
    }
  },
  created() {
    this.setUser()
    if (!this.currentCompany){
      const currentCompany = JSON.parse(sessionStorage.getItem('company')) || this.$localEncrypt.getData('currentCompany')

      if (currentCompany) {
        this.saveCurrentCompany(currentCompany);
      }
      else{
        this.UserModel.getCurrentCompany().then(r => {
          this.saveCurrentCompany(r.data)
        })
      }
    }
    const companies = this.$localEncrypt.getData('___kpshDPssoai__')
    if (companies){
      this.companies = companies
    } else {
      this.getUserCompanies()
    }
  },
  beforeMount() {
            this.getSearchEngineSettings()
        },
  mounted() {
    window.addEventListener("keydown", this.handleShortcut);
    document.querySelector('.sfe-layout__wrapper.flex-row.pr-4')?.classList.remove('pr-4');
    document.querySelector('.pt-2.flex-grow-1.sfe-layout__content')?.classList.remove('pt-2');

    // Initialize BroadcastChannel for logout
    this.logoutChannel = new BroadcastChannel('logout_channel');
    this.logoutChannel.onmessage = (event) => {
      if (event.data === 'logout') {
        this.performLogout();
      }
    };
    
    // Listen for idle timeout logout from other tabs
    window.addEventListener('storage', (e) => {
      if (e.key === 'idle_timeout_logout' && e.newValue === 'true') {
        localStorage.removeItem('idle_timeout_logout');
        this.performLogout();
      }
    });

    const targetEl = document.querySelector('.sfe-btn.sfe-btn-bare-neutral.sfe-icon-btn.sfe-icon-btn-size-md.ml-auto');

    if (targetEl) {
      targetEl.innerHTML = `
        <svg id="sideBarBtn" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.25 0C1.45507 0 0 1.45507 0 3.25V14.75C0 16.5449 1.45507 18 3.25 18H14.75C16.5449 18 18 16.5449 18 14.75V3.25C18 1.45507 16.5449 0 14.75 0H3.25ZM1.5 3.25C1.5 2.2835 2.2835 1.5 3.25 1.5H5.5V16.5H3.25C2.2835 16.5 1.5 15.7165 1.5 14.75V3.25ZM7 16.5V1.5H14.75C15.7165 1.5 16.5 2.2835 16.5 3.25V14.75C16.5 15.7165 15.7165 16.5 14.75 16.5H7Z" fill="black" fill-opacity="0.7"/>
        </svg>
    `;
    }

    // it was split into mounted and created hooks so that the user_role data property will be resolved already
    // and this will allow the "job management" option to be in the dom and be seen as a .sidebar-item link
    window.addEventListener('online',  this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
    // continue from here
    this.sidebarItems = document.querySelectorAll('.sidebar-item')

    this.sidebarItems.forEach((sidebarItem) => {
      sidebarItem.addEventListener('mouseenter', this.mouseEnterCallback)
      sidebarItem.addEventListener('mouseleave', this.mouseLeaveCallback)
      sidebarItem.addEventListener('click', this.toggleDropdown)
    })
    this.getProductNotifications()

    // Initialize idle timeout (synced with IDLE_PERIOD_SESSION_TIMEOUT on the server)
    const idlePeriodMs = (window.appSettings?.idlePeriodSessionTimeoutSeconds ?? 1800) * 1000;
    this.idleTimeoutService = new IdleTimeoutService({
      idleTime: idlePeriodMs,
      countdownTime: 30,
      onShowModal: (secondsLeft) => {
        this.$set(this.idleModal, 'open', true);
        this.$set(this.idleModal, 'secondsLeft', secondsLeft);
      },
      onHideModal: () => {
        this.idleModal.open = false;
      },
      onCountdown: (secondsLeft) => {
        this.idleModal.secondsLeft = secondsLeft;
      },
      onTimeout: () => {
          // Signal other tabs to logout via localStorage
          try {
            localStorage.setItem('idle_timeout_logout', 'true');
            // Remove immediately to allow re-triggering
            setTimeout(() => localStorage.removeItem('idle_timeout_logout'), 100);
          } catch (e) {
            console.error('Error setting logout signal:', e);
          }
          this.performLogout();
      }
    });
    this.idleTimeoutService.start();
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleShortcut);
    window.removeEventListener('online',  this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);

    // Clean up BroadcastChannel
    if (this.logoutChannel) {
      this.logoutChannel.close();
    }

    this.sidebarItems.forEach((sidebarItem) => {
      sidebarItem.removeEventListener('mouseenter', this.mouseEnterCallback)
      sidebarItem.removeEventListener('mouseleave', this.mouseLeaveCallback)
      sidebarItem.removeEventListener('click', this.toggleDropdown)
    })

    if (this.idleTimeoutService) {
      this.idleTimeoutService.stop();
    }
  },
  methods: {
    goToApplicantPage(id) {
      this.hideOptions();
      this.$router.push({
        name: 'Admin.Applicants.CandidateOverview', 
        params: { id } 
      })
    },
    handleSeachEmit(e) {
      this.search = e;
    },
    handleShortcut(e) {
      const isMac = navigator.platform.toUpperCase().includes("MAC");
      const isCmdK = isMac ? e.metaKey && e.key === "k" : e.ctrlKey && e.key === "k";
      if (isCmdK) {
        const input = document.querySelector('.input-field');
        this.inputSearchValue = input.value;
        const ariaValue = document.getElementById('dropdown-trigger-2');
        if(ariaValue) ariaValue.click();
        if(input) input.focus();
        this.shortCutUsed = true;
      }
    },

    takeAction(item) {
      this.hideOptions();
      if(item.name == "Create a Job") {
        sessionStorage.clear()
        localStorage.removeItem('third_party_data')
        this.trackEvent('Create Job (global-search)');
        this.$router.push({
          name: 'Admin.Job.Details',
          params: {
            action: 'create'
          }
        })
      }else if (item.params !== '') {
        this.$router.push({
          name: item?.route,
          params: {
            action: item?.params
          }
        })
      }else {
        this.$router.push({
          name: item.route
        })

      }
    },
    handleSearchItemValue(value) {
      this.subsidiarySearch = value;
    },

    /**
     * return an object from the group.
     *
     * @param {any} value
     * @return void
     */
    determineActiveTab(value) {
      return value?.items?.some(item => this.isSidebarSubLinkActive(item)) ?? false
    },

    isSidebarSubLinkActive(link) {
      if (!link) return false

      const currentRoute = this.$route.name
      if (!currentRoute) return false

      if (link.routeName === currentRoute) return true

      if (Array.isArray(link.activeRouteNames) && link.activeRouteNames.includes(currentRoute)) {
        return true
      }

      if (link.activeRoutePrefix && String(currentRoute).startsWith(link.activeRoutePrefix)) {
        return true
      }

      return false
    },

    handleShowNotification() {
      this.showNotificationsLightBox = !this.showNotificationsLightBox;
    },

    markWord(text, wordToMark){
        return text?.replace(new RegExp(wordToMark, 'gi'), '<mark class="bg-highlight text-dark">' + wordToMark + '</mark>')

    },
    handleSearch(){
      this.hasUsedTheGlobalSearch = sessionStorage.getItem('usedGlobalSearch') === 'true';

      if(!this.hasUsedTheGlobalSearch) {
        this.trackEvent('Admin used the global search');
        this.hasUsedTheGlobalSearch = true;
        sessionStorage.setItem('usedGlobalSearch', 'true');
      }
      this.searchAlgoliaData()
      this.getJobListing()
      this.actionSearch()
    },

    actionSearch() {
      if(this.search.length) {
        const query = this.search.trim();
        const fuse = new Fuse(this.actionsToShow, {
          keys: ["name", "keywords"],
          threshold: 0.4, 
        });
  
        this.matchedActions = fuse.search(query);
      }

    },
    searchAlgoliaData(){
        if(this.search.length){
            this.applicantLoadingState = true
            this.algoliaIndexing.search('', {
                facets: ['applicant_type','completed_nysc','course_of_study','custom_field_value','cv_source','gender','highest_qualification','last_company_worked','last_position','maximum_remuneration','minimum_remuneration','school','specializations','state','willing_to_relocate','years_of_experience'],
                hitsPerPage: 10,
                query: `${this.search}`,
                filters: `company_id=${this.$store?.state.companyId}`,
                distinct: true
            })
            .then(({ query, nbHits, hits }) => {
                this.applicantData = { query, nbHits, hits }
            })
            .finally(() => {
                this.applicantLoadingState = false
            })
        }
    },

    getJobListing(){
        if(this.search.length){
            this.jobLoadingState = true
            this.JobModel.getJobListing({ search: this.search })
            .then(r => {
                this.jobData = r.data.data
            })
            .finally(() => {
                this.jobLoadingState = false
            })
        }
    },

    getSearchEngineSettings(){
        this.isLoading = true
        this.AdminModel.getSearchEngineSettings()
        .then((resp) => {
            const { SEARCH_ENGINE_ID, SEARCH_ENGINE_SECRET } = resp.data

            this.searchClient = algoliasearch(
                                            AsymmetricEncryptionService.decryptFromBackend(SEARCH_ENGINE_ID),
                                            AsymmetricEncryptionService.decryptFromBackend(SEARCH_ENGINE_SECRET)
                                          )
            this.algoliaIndexing = this.searchClient.initIndex('job_applications')
        })
        .finally(() => this.isLoading = false)
    },

    goToJobAppliaction(id) {
      this.$router.push({
        name: 'Admin.Applicants.Overview',
        params: { id }
      })
      this.hideOptions();
    },
    hideOptions() {
      const input = document.querySelector('.input-field');
      if(input) {
        input.blur();
        input.value = '';
      }
      
      const ariaValue = document.getElementById('dropdown-trigger-2');

      if(ariaValue) ariaValue.blur();
      const tippyDiv = document.getElementById('tippy-1');
      if(tippyDiv) tippyDiv.style.visibility = 'hidden';
      this.search = '';
      this.inputSearchValue = '';
      this.shortCutUsed = false;
    },

    goToTalentPool() {
        this.$store.commit('SET_SEARCH_QUERY', this.search)
        this.$router.push({
            name: 'Admin.Applicants.AllCandidates'
        })
        this.hideOptions();
    },
    getNotificationCount(count) {
      this.notificationCount = count
    },
    goToTemplatesPage() {
      this.$router.push({
        name: 'Admin.Templates.InterviewNotes'
      })
    },
    goToHrmsPage() {
      if(this.hrmsDetails?.is_linked) {
        window.open(this.hrmsDetails.url, '_blank')
      }
    },
    goToGeneralSettingsPage() {
      this.trackEvent(`User navigates to general settings`);
      this.$router.push({
        name: 'Admin.Settings.Company'
      })
    },
    setUser() {
      let user = localStorage.getItem('loggedInUser')
      if (!user) {
        this.getCurrentUser().then((userData) => {
          this.$store.commit('SET_LOGGED_IN_USER', userData)
          this.user = userData
        })
      } else {
        user = JSON.parse(user)
        this.$store.commit('SET_LOGGED_IN_USER', user)
        this.user = user
      }
    },
    getCurrentUser() {
      return this.UserModel.getCurrentUser().
      then((r) => {
        return r.data
      })
    },
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === 'online';
    },
    gotoCareersPage(){
      location.href = `/${this.currentCompany?.slug}`
    },
    determineSidebarInnerContainerElement (event) {
      const sidebarItemElement = event.target
      const sidebarInnerContainerElement = sidebarItemElement.querySelector('.sidebar-item--inner-container')
      return sidebarInnerContainerElement
    },
    elementContainsActiveLink(event) {
      // this checks if the 'active-link is on the parent element
      const element = event.target
      return element.classList.contains('.active-link') || !!element.closest('.active-link')
    },
    calculateActiveAndInactiveImageFiles(element) {
      const currentImagePath =  new URL(element.children[0].src).pathname

      const arrayWithImagePathAndFileName = currentImagePath.split('.')
      const pathWithoutFileName = arrayWithImagePathAndFileName[0]


      let activeImagePathWithoutFileName
      let inactiveImagePathWithoutFileName
      if (pathWithoutFileName.includes('-active')) {
        activeImagePathWithoutFileName = pathWithoutFileName
        inactiveImagePathWithoutFileName = pathWithoutFileName.split('-active')[0]
      } else {
        activeImagePathWithoutFileName = `${pathWithoutFileName}-active`
        inactiveImagePathWithoutFileName = pathWithoutFileName
      }
      const activeImagePathWithFileName = `${activeImagePathWithoutFileName}.${arrayWithImagePathAndFileName[1]}`
      const inactiveImagePathWithFileName =  `${inactiveImagePathWithoutFileName}.${arrayWithImagePathAndFileName[1]}`

      return {
        activeImageFile: activeImagePathWithFileName,
        inactiveImageFile: inactiveImagePathWithFileName
      }
    },
    mouseEnterCallback(event) {
      const sidebarInnerContainerElement = this.determineSidebarInnerContainerElement(event)
      const inactiveImageFile = this.calculateActiveAndInactiveImageFiles(sidebarInnerContainerElement).inactiveImageFile
      sidebarInnerContainerElement.children[0].setAttribute('src', inactiveImageFile)
    },
    mouseLeaveCallback(event) {
      const sidebarInnerContainerElement = this.determineSidebarInnerContainerElement(event)
      const inactiveImageFile = this.calculateActiveAndInactiveImageFiles(sidebarInnerContainerElement).inactiveImageFile
      const activeImageFile = this.calculateActiveAndInactiveImageFiles(sidebarInnerContainerElement).activeImageFile

      if (!this.elementContainsActiveLink(event)) {
        sidebarInnerContainerElement.children[0].setAttribute('src', inactiveImageFile)
      } else {
        sidebarInnerContainerElement.children[0].setAttribute('src', activeImageFile)
      }
    },
    toggleDropdown(event) {
      const sidebarItemElement = event.target
      const sidebarDropdown = sidebarItemElement.closest('.sidebar-item--inner-container').nextElementSibling

      if (sidebarDropdown) {
        if (sidebarDropdown.classList.contains('active')) {
          sidebarDropdown.classList.remove('active')
        } else {
          sidebarDropdown.classList.add('active')
        }
      }
    },
    switchUserCompanies(companyId){
      this.UserModel.switchUserCompanies(companyId).then(r => {
        this.saveCurrentCompany(r.data)
        if(this.$route.name === 'Admin.Dashboard'){
          window.location.reload()
        }else{
          this.$router.push({ name: 'Admin.Dashboard' })
        }

      })
    },
    getUserCompanies(){
      this.UserModel.getUserCompanies().then(r => {
        this.companies = r.data
        this.$localEncrypt.saveData('___kpshDPssoai__', r.data)

        if (r.data.length){
          if (this.$helpers.isObject(this.currentCompany)
              && this.$helpers.isEmptyObj(this.currentCompany)){
            this.saveCurrentCompany(r.data[0])
          }
        }
      })
    },
    saveCurrentCompany(company){
      this.currentCompany = company
      this.$store.commit('SET_COMPANY_ID', company?.id)
      this.$store.commit('SET_COMPANY', company)
      this.$localEncrypt.saveData('currentCompany', company)
    },
    isActiveLink(routePaths = []) {
      return routePaths.some(v => !!this.$route.path.includes(v))
    },
    getProductNotifications(){
      this.AdminModel.getProductNotifications()
          .then(resp => {
            this.notifications = resp.data.data
          })
    },
    goToList(){
      this.$router.push({ name: 'Admin.Product.Notification' })
    },
    handleLogout() {
      this.showInfoPrompt('Are you sure that you want to logout?', 'Logout')
          .then((r) => {
            if (r.isConfirmed) {
              this.performLogout();
            }
          })
    },
    performLogout() {
      if (this.logoutChannel) {
        this.logoutChannel.postMessage('logout');
      }
      // Clear all stored data
      localStorage.clear();
      sessionStorage.clear();
      this.$localEncrypt.removeAll();

      // Redirect to logout URL
      window.location.href = '/logout';
    },
  },
  watch: {
    onLine(v) {
      setTimeout(()=>{ this.showBackOnline = v; }, 100);
      this.$forceUpdate()
    },
    isSidebarCollapsed(newVal) {
      const svg = document.getElementById('sideBarBtn');
      if (svg) {
        svg.style.transform = newVal ? 'scaleX(-1)' : 'scaleX(1)';
        svg.style.transition = 'transform 0.2s ease';
      }
    },
    'search': {
      immediate: true,
      deep: true,
      handler(newValue) {
        if(newValue) {
          this.handleSearch()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.overlay-attr {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background: rgba(0, 0, 0, 0.5);
  background-color: rgba(4, 22, 40, 0.5);
  z-index: 999;
}

::v-deep .search-dropdown {
  margin-left: 200px;
}
.company-list-item {
  width: 255px;
  &:hover {
    color: #296DB3 !important;
  }
}
.header-visibility{
  z-index: 3;
}

.dropdown-menu {
  width: 560px !important;
  left: 29%;
  right: 0;
  top: 0;
}

.search-result-item {
  max-height: 400px;
  overflow-y: scroll;
  z-index: 999;
}

.truncated-text {
  max-width: 20ch;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
